
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/avtor/[alias]/sorting/nazvanie",
      function () {
        return require("private-next-pages/avtor/[alias]/sorting/nazvanie/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/avtor/[alias]/sorting/nazvanie"])
      });
    }
  